@if (isLoading) {
  <div class="loading-shade">
    @if (isLoading) {
      <mat-spinner></mat-spinner>
    }
  </div>
}

